import Vue from 'vue'
import App from '@/App.vue'
import csvparser from 'papaparse'
import router from '@/router/router'
import { store } from '@/store'
import twemoji from 'twemoji'
import vuetify from '@/plugins/vuetify';
import sounds from '@/plugins/sounds'
import VueTheMask from 'vue-the-mask'
import 'vue-datetime/dist/vue-datetime.css'
import VueMeta from 'vue-meta'
import events from '@/events/events'

import '@/components/components'
import '@/plugins/axios'
import '@/plugins/colors'
import '@/plugins/vue-filters'
import '@/plugins/images'
import '@/plugins/directives'
import '@/plugins/vee-validate'
import '@/utility/listeners'

//  Assign globals to the window
window.$ = window.jQuery = require('jquery') //  We use jQuery in a few places

//  Lodash import only what we need
window._ = {} //  Lodash helps with debounce and cloning
window._.camelCase = require('lodash/camelCase')
window._.cloneDeep = require('lodash/cloneDeep')
window._.differenceBy = require('lodash/differenceBy')
window._.flatten = require('lodash/flatten')
window._.get = require('lodash/get')
window._.isEmpty = require('lodash/isEmpty')
window._.isEqual = require('lodash/isEqual')
window._.isNil = require('lodash/isNil')
window._.pick = require('lodash/pick')
window._.reject = require('lodash/reject')
window._.upperFirst = require('lodash/upperFirst')
window._.extend = require('lodash/extend')

window.csvparser = csvparser
window.sounds = sounds
window.twemoji = twemoji

//  Set Environment
document.title = process.env.VUE_APP_NAME

//  Enables/disables our dev tools based on env
Vue.config.devtools = process.env.VUE_APP_DEVTOOLS === 'true'

//  Get our shortKeys library
const shortKeys = require('vue-shortkey')

//  Attach plugins/extensions
Vue.config.productionTip = false
Vue.use(VueTheMask)
Vue.use(VueMeta)
Vue.use(shortKeys, { prevent: ['textarea', 'input', '[contenteditable]'] })

// -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// Allow `<zapier-app-directory>` custom element
// -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
Vue.config.ignoredElements = ["zapier-app-directory"];

// Grab tokens from local storage on application load to log user back in if they were logged in before
const userToken = localStorage.getItem('token')
const twoFactorToken = localStorage.getItem('two_factor_token')

const payload = {
    userToken: userToken,
    twoFactorToken: twoFactorToken,
}

//  Attempt to signin with a token stored locally
store.dispatch('authUserGet', payload).then(() => {
    const vm = new Vue({
        router,
        store,
        vuetify,
        render: h => h(App),
        mounted: () => events.onApplicationLoaded()
    }).$mount('#app')
    
    window.root = vm
})

//  Declare the custom entities we will attach to the 'window' object (Typescript)
declare global { interface Window {
    $: any
    _: any
    analytics: any                                                                  //  Segment
    axios: any                                                                      //  Axios HTTP
    Cypress: any                                                                    //  Cypress test utility
    csvparser: any                                                                  //  csvparser utility
    Echo: any                                                                       //  Laravel Echo
    getDate: (str: string) => Date                                                  //  Helper function
    getFileContent: (url: string) => Promise<string>                                //  Helper function
    getProps: (obj: Object, props: Array<string>, str?: string) => any              //  Helper function
    goToLink: Function                                                              //  Helper function
    goToUser: Function
    gtag: any                                                                       //  Google Tag Manager
    Intercom: any                                                                   //  Intercom
    INTERCOM_APP_ID: string                                                         //  Intercom
    intuit: any,                                                                    //  Intuit
    jQuery: any
    opera: any                                                                      //  Opera Browser
    opr: any                                                                        //  Opera Browser
    profitwell: any                                                                 //  ProfitWell
    Pusher: any                                                                     //  Pusher websockets
    popSupportMessenger: () => Promise<void>                                        //  Helper function
    removeDuplicatesById: (arr1: Array<Object>, arr2: Array<Object>, arr3?: object[]) => Array<any>  //  Helper function
    removeDuplicatesByIdUnshift: (arr1: Array<Object>, arr2: Array<Object>, arr3?: object[]) => Array<any>  //  Helper function
    root: any                                                                       //  The root Vue instance
    sounds: any                                                                     //  Sounds helper
    toUrlParams: (obj: any) => string 
    twemoji: any
    zxcvbn: any
}}
//  Import the implementations of our window functions and our other prototypes
import '@/plugins/helpers'